import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function ProductCard({ product, onRequest, index }) {
  return (
    <motion.article
      data-testid={`product-card-${product.id}`}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.7, delay: (index % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="group rounded-3xl border border-white/10 bg-navy-card overflow-hidden flex flex-col transition-colors duration-500 hover:border-lime/50"
    >
      <div className="relative aspect-[4/5] overflow-hidden spotlight-card flex items-center justify-center p-6">
        <img
          src={product.image}
          alt={`${product.name} ${product.variant}`}
          className={product.fit === "cover"
            ? "absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
            : "max-h-full w-auto object-contain drop-shadow-2xl transition-transform duration-700 ease-out group-hover:scale-[1.06] group-hover:-rotate-1"}
          loading="lazy"
        />
        <span className="absolute top-4 left-4 rounded-full bg-navy/80 backdrop-blur px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-sun-bright">
          {product.tag}
        </span>
      </div>
      <div className="p-6 flex flex-col gap-2 grow">
        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-lime">{product.variant}</p>
        <h3 className="font-display text-xl font-bold tracking-tight">{product.name}</h3>
        <p className="text-sm text-slate-400 leading-relaxed grow">{product.description}</p>
        <button
          data-testid={`product-request-pricing-btn-${product.id}`}
          onClick={() => onRequest(product)}
          className="mt-3 inline-flex items-center justify-between rounded-full border border-lime/40 px-5 py-3 text-sm font-bold text-lime transition-all duration-300 hover:bg-lime hover:text-navy group-hover:border-lime"
        >
          Request Pricing <ArrowUpRight size={16} />
        </button>
      </div>
    </motion.article>
  );
}
